// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"a710f1de","161":"fb23685c","256":"278c1f1d","312":"d01df465","363":"42e2b2ad","460":"410f594f","618":"0bab4394","744":"d70e67da","817":"fb61f697","873":"fd971f1a","950":"20a8a069","974":"54586c37"}[chunkId] + ".chunk.js";
};